export class ModelSummaryTime {
  constructor(
    public date: number,
    public running: number,
    public preparation: number,
    public stop: number,
    public alarm: number,
    public maintenance: number,
    public pause: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-summary-time.ts